import { styled, Checkbox } from "@mui/material";

export const ContainerLogin = styled("div")(() => ({
  backgroundColor: "#FAFAFA",
  width: "400px",
  padding: "24px 40px",
  borderRadius: "8px",
  margin: "0 auto",
  marginTop: "25vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "24px",
}));

export const Container = styled("div")(() => ({
  backgroundColor: "#FAFAFA",
  width: "100%",
  padding: "24px",
  borderRadius: "8px",
}));

export const CheckboxStyled = styled(Checkbox)(() => ({
  color: "#0197F6",
  padding: 0,
  "&.Mui-checked": {
    color: "#0197F6",
  },
}));
